import React, { useState, useEffect } from "react";
import { withRouter, Link, useHistory } from "react-router-dom";
import {
  getCityName,
  getLocationFromItem,

  getRatingsFromItem,
  
} from "../../utils";

import defaultImg from "../../assets/images/default.png";
import starImg from "../../assets/images/star-24px.svg";
import starFillImg from "../../assets/images/star-24px.svg";
import pinImg from "../../assets/images/ic_pin_small.svg";
import editImg from "../../assets/images/edit-primary.svg";
import editImgMobile from "../../assets/images/edit-pwa.png";
import deleteImg from "../../assets/images/delete-primary.svg";
import verifiedbadgeImg from "../../assets/images/verifiedbadge.svg";
import surveyImg from "../../assets/images/survey.svg";
import { useDispatch } from "react-redux";
import { addiopcenterAction } from "../../actions/index";
import DeleteConfirmationModal from "../modal/DeleteConfirmationModal.jsx";
import { SpinnerContext } from "../spinner/spinner.component.js";
import VerifiedBadgeModel from "../modal/VerifiedBadgeModel.js";
import PayPerClick from "../modal/payPerClick.component";
import CancelConfirmationModal from "../modal/cancelSubscription.component";
import cancleImg from "../../assets/images/cancle-primary.svg";
import upgradeImg from "../../assets/images/upgrade.svg";
import promotionsImg from "../../assets/images/promotions.svg";
import infoPrimary from "../../assets/images/info-primary.svg";
import infoWhite from "../../assets/images/info-white-1.svg";
import { Tooltip } from "../button/tool-tip.component";
import cancleImgMobile from "../../assets/images/cancle-subscription-mobile.svg";
import infoMobile from "../../assets/images/info-mobile.svg";
import NoImage from "../../assets/images/no-image.svg";
import doller from "../../assets/images/doller-imag.png";
const IOPCenterCard = (props) => {
  const item = props?.item;
  const {
    pageName,
    isRecommended,
    isHost,
    onDeleteLiving,
    isPreSaleSubscribed,
    preSalePlanType,
    isSubscribe,
    subscriptionDetail,
  } = props;
  const {isPPCSubscribed} = item;

  const [imageUrl, setImageUrl] = useState("");
  const [ratingStr, setRatingStr] = useState("");
  const [priceStr, setPriceStr] = useState("");
  const [locationStr, setLocationStr] = useState("");
  const [heading, setHeading] = useState("");

  const [stateStr, setStateStr] = useState("");
  const [isPromoted, setIsPromoted] = useState(false);
  const [objFit, setObjFit] = useState("cover");
  const [isSubscribed, setIsSubscribed] = useState("");
  const [openDeletemodal, setOpenDeletemodal] = useState(false);
  const [openVerifiedBadge, setOpenVerifiedBadge] = useState(false);
  const [openPPC, setOpenPPC] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const contextType = React.useContext(SpinnerContext);
  useEffect(() => {
    setImageUrl(getImageUrlFromItem());
    setRatingStr(getRatingsFromItem(item));
   
    setHeading(item?.name);
    setLocationStr(getLocationFromItem(item));
    setStateStr(item?.geocodingResult?.stateLong);
    setIsPromoted(item?.isPromoted);
    setIsSubscribed(item?.isSubscribed);
  }, [item]);

  const deleteLiving = (id) => {
    // Handle delete operation
  };

  const isTextLong = locationStr?.length > 20;
  const city = getCityName(item?.geocodingResult);

  const onImgLoad = ({ target: img }) => {
    try {
      if (img?.naturalWidth < img?.offsetWidth) {
        setObjFit("cover");
      } else {
        setObjFit("cover");
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <VerifiedBadgeModel
        open={openVerifiedBadge}
        onClose={() => setOpenVerifiedBadge(false)}
        id={item?.id}
      />
      <DeleteConfirmationModal
        open={openDeletemodal}
        onCancel={() => setOpenDeletemodal(false)}
        onDelete={onDeleteLiving}
        name={"iop"}
      />
      <CancelConfirmationModal
        open={openCancelModal}
        name={item?.facilityType}
        onCancel={() => setOpenCancelModal(false)}
        subscriptionId={item?.subscriptionDetail?.subscriptionId}
        facilityType={item?.facilityType}
        facilityId={item?.id}
        userId={item?.createdBy}
      />
      <PayPerClick
        open={openPPC}
        onClosePPC={() => setOpenPPC(false)}
        id={item?.id}
        isPPCSubscribed={item?.isPPCSubscribed}
        ppcSubscriptionDetail={item?.ppcSubscriptionDetail}
        houseType="iop"
        ppcPerClickPrice={item?.ppcPerClickPrice}
      />
      <div className="sober-living-slider_item w-100">
        <Link
          className="card text-decoration-none d-flex flex-wrap flex-row"
          to={{
            pathname: `/owner/facility/iopfacility/view/${item?.id}`,
            state: { property: item },
          }}
          onClick={() => contextType.setClaimedFacility(false)}
        >
          <div className="card-img" onClick={() => deleteLiving(item?.id)}>
            <img
              className="img-fluid"
              src={imageUrl ? imageUrl : NoImage}
              style={{ objectFit: objFit }}
              onLoad={onImgLoad}
              onError={() => setImageUrl(defaultImg)}
              alt={item.name}
            />
            {pageName === "Profile" ? (
              <div>
                {isHost === true && (preSalePlanType || isSubscribed) ? (
                  (preSalePlanType === "pro" && isPreSaleSubscribed) ||
                  subscriptionDetail?.subscriptionType === "pro" ? (
                    <span className="subscription-msg">Pro</span>
                  ) : (
                    <span className="subscription-msg unsubscribed">Basic</span>
                  )
                ) : (
                  <span className="subscription-msg listed">
                    Not Subscribed
                  </span>
                )}
              </div>
            ) : (
              ""
            )}
            {isPPCSubscribed && (
              <div>
              <span className="subscription-msg adTag">Ad</span>
              </div>
            )}
          </div>
          {!isRecommended ? (
            <div className="card-body">
              <div className="property-wrapper d-flex flex-column flex-md-row justify-content-between w-100 h-100 border-0 pr-0">
                <div className="card-content-left d-flex flex-column py-2">
                  <div className="card-heading">
                    <span>
                      {heading.length > 50
                        ? heading
                            .slice(0, 50)
                            .split(" ")
                            ?.map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase()
                            )
                            .join(" ")
                        : heading
                            .split(" ")
                            ?.map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase()
                            )
                            .join(" ")}{" "}
                    </span>
                    <span className="card-actions d-flex d-md-none align-items-center">
                      {!item?.subscriptionDetail?.subscriptionId && (
                        <button className="owner-card-action-button subscription-pending d-block d-md-none">
                          <Tooltip message="Subscription pending. Subscribe your facility to get listed on the homepage.">
                            <img
                              src={infoMobile}
                              className="img-fluid"
                              alt="infoMobile"
                            />
                          </Tooltip>
                        </button>
                      )}
                      {item?.subscriptionDetail?.subscriptionId && (
                        <button
                          className="owner-card-action-button d-flex d-md-none"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenCancelModal(true);
                          }}
                        >
                          <img
                            src={cancleImgMobile}
                            className="img-fluid"
                            alt="cancleImgMobile"
                          />
                        </button>
                      )}
                      <button
                        className="owner-card-action-button -disabled"
                        onClick={(e) => {
                          setOpenDeletemodal(true);
                          e.preventDefault();
                        }}
                      >
                        <img src={deleteImg} className="img-fluid" alt="deleteImg" />
                      </button>
                    </span>
                  </div>
                  <span className="location" title={locationStr}>
                    <img src={pinImg} className="img-fluid" alt="location" />{" "}
                    {isTextLong
                      ? `${locationStr.slice(0, 20)}...`
                      : locationStr}
                  </span>
                  {isSubscribed == true && (
                    <span className="location star-rating">
                      <img src={starImg} className="img-fluid" alt="starImg" />{" "}
                      {ratingStr}
                    </span>
                  )}
                  <>
                    {(item?.rentRange?.from || item?.rentRange?.to) && (
                      <div className="card-price">
                        ${item?.rentRange?.from} - ${item?.rentRange?.to}{" "}
                      </div>
                    )}
                  </>
                </div>
                <div className="card-content-right d-flex flex-column justify-content-between">
                  <span className="card-actions">
                    {!item?.subscriptionDetail?.subscriptionId && (
                      <button className="owner-card-action-button subscription-pending d-none d-md-block">
                        <Tooltip message="Subscription pending. Subscribe your facility to get listed on the homepage.">
                          <img src={infoPrimary} className="img-fluid" alt="infoPrimary" />
                        </Tooltip>
                      </button>
                    )}
                    {item?.subscriptionDetail?.subscriptionId && (
                      <button
                        className="owner-card-action-button d-none d-md-flex"
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenCancelModal(true);
                        }}
                      >
                        <img src={cancleImg} className="img-fluid" alt="cancleImg" />
                      </button>
                    )}
                    <button
                      className="owner-card-action-button edit-btn"
                      onClick={(e) => {
                        dispatch(
                          addiopcenterAction.getByIdIopcenterdeatials(
                            item?.id,
                            item
                          )
                        );
                        history.push(`/owner/facility/iopfacility/edit-iopcenter/${item?.id}/1`);
                        e.preventDefault();
                      }}
                    >
                      <img
                        src={editImg}
                        className="img-fluid d-none d-md-block"
                        alt="editImg"
                      />
                      <img
                        src={editImgMobile}
                        className="img-fluid d-block d-md-none"
                        alt="editImgMobile"
                      />
                    </button>
                    <button
                      className="owner-card-action-button d-none d-md-flex"
                      onClick={(e) => {
                        setOpenDeletemodal(true);
                        e.preventDefault();
                      }}
                    >
                      <img src={deleteImg} className="img-fluid" alt="action-button" />
                    </button>
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div className="card-body">
              <div className="property-wrapper d-flex flex-column flex-md-row justify-content-between w-100 h-100 border-0 pr-0">
                <div className="card-content-left d-flex flex-column py-2">
                  <div className="card-heading">
                    <span>
                      {heading.length > 50
                        ? heading
                            .slice(0, 50)
                            .split(" ")
                            ?.map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase()
                            )
                            .join(" ")
                        : heading
                            .split(" ")
                            ?.map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase()
                            )
                            .join(" ")}{" "}
                    </span>
                  </div>
                  <span className="location">
                    <img src={pinImg} className="img-fluid" alt="pinImg" />{" "}
                    {isTextLong
                      ? `${locationStr?.slice(0, 20)}...`
                      : locationStr}
                  </span>
                  {isSubscribed == true && (
                    <span className="location star-rating">
                      <img src={starFillImg} className="img-fluid" alt="starFillImg" />{" "}
                      {ratingStr}
                    </span>
                  )}
                </div>
                <div className="card-content-right d-flex flex-column justify-content-between">
                  <span className="card-actions">
                    {item?.subscriptionDetail?.subscriptionId && (
                      <button
                        className="owner-card-action-button d-none d-md-flex"
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenCancelModal(true);
                        }}
                      >
                        <img src={cancleImg} className="img-fluid" alt="cancleImg" />
                      </button>
                    )}
                    <button
                      className="owner-card-action-button edit-btn"
                      onClick={(e) => {
                        dispatch(
                          addiopcenterAction.getByIdIopcenterdeatials(
                            item?.id,
                            item
                          )
                        );
                        history.push(`/living/edit-living/${item?.id}`);
                        e.preventDefault();
                      }}
                    >
                      <img
                        src={editImg}
                        className="img-fluid d-none d-md-block"
                        alt="editImg"
                      />
                      <img
                        src={editImgMobile}
                        className="img-fluid d-block d-md-none"
                        alt="editImgMobile"
                      />
                    </button>
                    <button
                      className="owner-card-action-button d-none d-md-flex"
                      onClick={(e) => {
                        setOpenDeletemodal(true);
                        e.preventDefault();
                      }}
                    >
                      <img src={deleteImg} className="img-fluid" alt="deleteImg" />
                    </button>
                  </span>
                  <div className="card-btn-container mb-md-2">
                    <button
                      className="btn btn-primary-outline radius-20"
                      disabled={true}
                    >
                      <img
                        src={upgradeImg}
                        className="img-fluid d-block d-md-none"
                        alt="upgradeImg"
                      />
                      <span>Manage</span> Questionnaire
                    </button>
                    <button
                      className="btn btn-primary radius-20"
                      data-toggle="tooltip"
                      data-placement="top"
                      disabled={
                        item.verifyRequestStatus === "process" ||
                        item.verifyRequestStatus === "approved"
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        setOpenVerifiedBadge(true);
                      }}
                    >
                      <Tooltip message="Your facility would be quality-checked by Taste Recovery Team for accuracy and completeness. We would provide a verified badge to the facility center you requested for and that attracts more seekers.">
                        <img
                          src={verifiedbadgeImg}
                          className="img-fluid d-block d-md-none"
                          alt="verifiedbadgeImg"
                        />
                        <span>Request</span> Verified Badge
                      </Tooltip>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="card-btn-container mb-md-2">
            {(isPreSaleSubscribed || isSubscribe) && (
              <button
                className="btn btn-primary-outline radius-20"
                data-placement="top"
                onClick={(e) => {
                  e.preventDefault();
                  setOpenPPC(true);
                }}
              >
                <img
                  src={promotionsImg}
                  className="img-fluid d-block d-md-none"
                  alt="promotionsImg"
                />
                Promote facility
              </button>
            )}

            {isSubscribe && (
              <button
                data-placement="top"
                className={`btn btn-primary-outline radius-20 ${
                  item?.subscriptionDetail?.downgradeScheduled ||
                  item?.subscriptionDetail?.intervalChangeScheduled
                    ? "disabled"
                    : ""
                }`}
                disabled={
                  item?.subscriptionDetail?.downgradeScheduled ||
                  item?.subscriptionDetail?.intervalChangeScheduled
                }
                onClick={(e) => {
                  e.preventDefault();
                  history.push(`/owner/facility/iopfacility/edit-iopcenter/${item?.id}/2`, {
                    state: {
                      isUpgrade: true,
                      facilityId: item?.id,
                      facilityType: item?.facilityType,
                      subscriptionId: item?.subscriptionDetail?.subscriptionId,
                      userId: item?.createdBy,
                    },
                  });
                }}
              >
                <img
                  src={upgradeImg}
                  className="img-fluid d-block d-md-none"
                  alt="upgradeImg"
                />
                Change Plan
              </button>
            )}

            {isHost === true && !isSubscribed && (
              <button
                className="btn btn-primary-outline radius-20"
                data-placement="top"
                onClick={(e) => {
                  history.push(`/owner/facility/iopfacility/edit-iopcenter/${item?.id}/1`);
                  e.preventDefault();
                }}
              >
                <img
                  src={upgradeImg}
                  className="img-fluid d-block d-md-none"
                  alt="upgradeImg"
                />
                Change Plan
              </button>
            )}

            {(preSalePlanType === "pro" ||
              subscriptionDetail?.subscriptionType === "pro") && (
              <button
                className="btn btn-primary-outline radius-20"
                onClick={(e) => {
                  contextType.setFacilityId(item?.id);
                  contextType.setFacilityName(item?.name);
                  e.preventDefault();
                  history.push(`/manageSurvey`);
                }}
              >
                <img
                  src={surveyImg}
                  className="img-fluid d-block d-md-none"
                  alt="surveyImg"
                />
                <span>Manage</span> Questionnaire
              </button>
            )}
            {(isPreSaleSubscribed || isSubscribe) && (
              <button
                className="btn btn-primary radius-20 verified-badge-btn"
                data-toggle="tooltip"
                data-placement="top"
                disabled={
                  item.verifyRequestStatus === "process" ||
                  item.verifyRequestStatus === "approved"
                }
                onClick={(e) => {
                  e.preventDefault();
                  setOpenVerifiedBadge(true);
                }}
              >
                <Tooltip message="Your facility will be quality checked by our Taste Recovery Team. We will provide a verified badge on your facilities home page once all information has been approved.">
                  <img
                    src={verifiedbadgeImg}
                    className="img-fluid d-block d-md-none"
                    alt="verifiedbadgeImg"
                  />
                  <span>Request</span> Verified Badge
                </Tooltip>
              </button>
            )}
          </div>
        </Link>
      </div>
    </>
  );

  function getImageUrlFromItem() {
    const item = props?.item;
    if (!item || !item?.photos || item?.photos?.length === 0) {
      return " ";
    }
    const mainImage = item?.photos?.find((photo) => photo?.isMain);
    if (!mainImage?.thumbnails || mainImage?.thumbnails?.length === 0) {
      return mainImage?.path;
    }
    return mainImage?.thumbnails["thumb360w"];
  }

  function onCardClick() {
    let city = getCityName(props?.item?.geocodingResult);
    props.history.push(`living/sober-living-in${city}&id=${props?.item?.id}`);
  }
};

export default withRouter(IOPCenterCard);
